import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

const ErrorPostsListFallback = ({ resetErrorBoundary }) => {
    const { t } = useTranslation('errors');
    return (
        <div
            role="alert"
            className="flex flex-1 flex-col items-center justify-center space-y-3 p-8">
            <p className="text-center">{t('error_occured_fetch_data')} </p>
            <button className="text-icoBlue underline" onClick={resetErrorBoundary}>
                {t('commons:try_again')}
            </button>
        </div>
    );
};

ErrorPostsListFallback.propTypes = {
    resetErrorBoundary: PropTypes.func
};

export default ErrorPostsListFallback;
